import { READER_MENU_ITEMS } from '../ReaderMenuUtils';
import ReaderToolbarVertical from './ReaderToolbarVertical';
import ReaderToolbarHorizontal from './ReaderToolbarHorizontal';

type ToolbarVariant = 'vertical' | 'horizontal';

export type ToolbarItem = {
  id: string;
  labelKey: string;
  icon: React.ReactNode;
};

export interface SharedReaderToolbarVariantProps {
  activeId: string | null;
  items: ToolbarItem[];
  onItemClick: (id: string) => void;
}

interface ReaderToolbarProps {
  variant: ToolbarVariant;
  activeId: string | null;
  onItemClick: (id: string) => void;
}

const TOOLBAR_COMPONENTS: Record<
  ToolbarVariant,
  React.FC<SharedReaderToolbarVariantProps>
> = {
  vertical: ReaderToolbarVertical,
  horizontal: ReaderToolbarHorizontal,
};

export default function ReaderToolbar({
  variant,
  activeId,
  onItemClick,
}: Readonly<ReaderToolbarProps>) {
  const ReaderToolbarVariant = TOOLBAR_COMPONENTS[variant];

  return (
    <ReaderToolbarVariant
      activeId={activeId}
      onItemClick={onItemClick}
      items={READER_MENU_ITEMS}
    />
  );
}
